module.exports = __webpack_public_path__ + "static/media/file-csv.031696ef.svg";